import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GMapMarker = _resolveComponent("GMapMarker")!
  const _component_GMapMap = _resolveComponent("GMapMap")!

  return (_ctx.values['hasLocation'])
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_GMapMap, {
          center: _ctx.input.initialValues(_ctx.values),
          zoom: 13,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.input.addMarkerFromClick(_ctx.values, $event))),
          style: {"width":"100%","height":"900px"}
        }, {
          default: _withCtx(() => [
            (_ctx.values['location'])
              ? (_openBlock(), _createBlock(_component_GMapMarker, {
                  key: 0,
                  position: _ctx.values['location'].position
                }, null, 8, ["position"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["center"])
      ]))
    : _createCommentVNode("", true)
}